import config from '@/utility/config';
import { t } from '@/utility/localization';
import {
  CREATE_MAGIC_REACH_ROUTE,
  getCommunityCheckoutRoute
} from '@/utility/routesHelper';

import {
  SIGNUP_REQUESTOR,
  WHATSAPP_SIGNUP_REQUESTOR
} from '@/features/SignUpPopup/constants';

import { PRODUCT_TYPE } from '@/contexts/LibrarySetupContext/constants';

export function shouldHideDrawerNav(pathname) {
  try {
    const hideForRoutes = [CREATE_MAGIC_REACH_ROUTE];
    return hideForRoutes.includes(pathname);
  } catch (e) {
    return false;
  }
}

export const isActivePathName = ({ pathName, route }) => {
  // to include sub-routes of the current pathname e.g. `/link/123` is sub-route for `/link`
  const includeSubRoutes = !!route?.includeSubRoutes;

  if (includeSubRoutes && pathName.includes(route.link)) return true;

  if (!includeSubRoutes && pathName === route.link) return true;

  if (pathName === route.alternateLink) {
    return true;
  }

  if (route.relatedRoutes?.includes(pathName)) {
    return true;
  }

  return false;
};

export const getShareUrlCheckoutParams = ({
  entityType,
  entityData,
  communityData
}) => {
  if (!entityData || !communityData || entityData?.access !== 'paid')
    return null;

  if (entityType === 'event') {
    return {
      checkoutLabel: t('event-checkout-link'),
      checkoutToolTip: t('checkout-link-to-your-event'),
      checkoutLink: `${config.siteBaseUrl}${getCommunityCheckoutRoute({
        communityCode: communityData?.code,
        communityId: communityData?._id,
        sourceInfo: {
          origin: entityData?._id,
          type: 'event'
        },
        requestor: communityData?.isWhatsappExperienceCommunity
          ? WHATSAPP_SIGNUP_REQUESTOR
          : SIGNUP_REQUESTOR
      })}`
    };
  }
  if (
    entityType === 'folder' &&
    entityData?.type !== PRODUCT_TYPE.SESSION
  ) {
    return {
      checkoutLabel: t('product-checkout-link'),
      checkoutToolTip: t('checkout-link-to-your-product'),
      checkoutLink: `${config.siteBaseUrl}${getCommunityCheckoutRoute({
        communityCode: communityData?.code,
        communityId: communityData?._id,
        sourceInfo: {
          origin: entityData?._id,
          type: 'folder'
        },
        requestor: communityData?.isWhatsappExperienceCommunity
          ? WHATSAPP_SIGNUP_REQUESTOR
          : SIGNUP_REQUESTOR
      })}`
    };
  }
};

// Return boolean.
export const showCheckoutWidgetSection = (community) => {
  try {
    const { link } = community;

    const {
      allowCheckoutWidgetForAll,
      whitelistedCommLinkForCheckoutWidget
    } = config;

    if (allowCheckoutWidgetForAll) return true;

    const commLinksArr =
      whitelistedCommLinkForCheckoutWidget?.split(',') || [];
    return commLinksArr.includes(link?.toLowerCase());
  } catch (e) {
    return false;
  }
};
